import { render } from "./JiraLink.vue?vue&type=template&id=ef6fd1e8&scoped=true"
import script from "./JiraLink.vue?vue&type=script&lang=js"
export * from "./JiraLink.vue?vue&type=script&lang=js"

import "./JiraLink.vue?vue&type=style&index=0&id=ef6fd1e8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6fd1e8"]])

export default __exports__